export default from './Banner';



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Banner/index.js